import React from "react";
import CDLEImage from "../images/2024CDLEBANNER.png";

const HeaderContent = () => {
    return(
      <header className="headerGridContainer">
      <div className="grid-item-1">
          <img id="HyperLink1" alt="CDLE, Colorado Department of Labor and Employment" src={CDLEImage} />
      </div>
      <div className="grid-item-2">
          <p id="workersComp">Division of Workers' Compensation</p>
          <p>707 17th St., Suite 2300, Denver, CO 80202-3404<br /> (303) 318-8000 | <a aria-label="colorado.gov/cdle, Colorado Department of Labor and Employment website" href="https://cdle.colorado.gov/" tabIndex="0" target="_blank" rel="noopener noreferrer">colorado.gov/cdle </a></p>
      </div>
  </header>
    );
};
export default HeaderContent;